require('./../css/style.css');
import alertify from './../../../../uPortal/Content/js/Plugins/AlertifyJS';
import decodeEmails from "./../../../../uPortal/Content/js/Plugins/AntiSpider";

function initCustomFooter() {
    decodeEmails();
    addLastTweetLinksAttr();

    const forms = document.querySelectorAll(".js-newsletter");
    const formsArray = Array.from(forms);

    formsArray.forEach((form) => {
        const formSubmitBtn = form.querySelector(".js-newsletter__submit");
        const formSuccessMessage = form.dataset.success;
        const formErrorMessage = form.dataset.error;

        formSubmitBtn.addEventListener("click", (event) => {
            const isFormValid = $(form).valid();
            if (!isFormValid) {
                event.preventDefault();
            }
        });

        form.successCallback = () => {
            form.reset();
            alertify.set('notifier', 'position', 'top-center');
            alertify.success(formSuccessMessage);
        };

        form.errorCallback = () => {
            form.reset();
            alertify.set('notifier', 'position', 'top-center');
            alertify.error(formErrorMessage);
        }
    });

    function addLastTweetLinksAttr() {
        const links = document.querySelectorAll(".js-last-tweet a");
        for (var i = 0; i < links.length; i++) {
            links[i].setAttribute('target', 'blank');
        }
    }
}

export default initCustomFooter;


// WEBPACK FOOTER //
// ./Core/Shared/CustomFooter/Js/index.js